import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faExclamationCircle,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'h3-help-tooltip',
  templateUrl: './help-tooltip.component.html',
  styleUrls: ['./help-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, MatTooltip, NgClass],
})
export class HelpTooltipComponent {
  @Input({ required: true }) text!: string;

  @Input() type: 'question' | 'exclamation' = 'question';

  getIcon() {
    if (this.type === 'exclamation') {
      return faExclamationCircle;
    } else {
      return faQuestionCircle;
    }
  }
}
